import ThetaJS from '../libs/thetajs.esm';
import TrezorConnect from '@trezor/connect-web';
import Web3 from 'web3';
import Wallet from './Wallet'
import Theta from "./Theta.js"

const rpcURL = "https://mainnet.infura.io/v3/40980e2189924c8abfc5f60dd2e5dc4b";
const web3 = new Web3(rpcURL);
let selectedDevice = null;

export default class Trezor {
    static setDevice(device){
        selectedDevice = device;
    }

    static clearDevice(){
        selectedDevice = null;
    }

    static async signTransaction(unsignedTx, device = selectedDevice){
        const expectedState = device && device.state && device.state.staticSessionId;
        if(!expectedState){
            throw new Error("Unable to verify the active Trezor session. Please reconnect your device.");
        }

        let payload = Theta.prepareTxPayload(unsignedTx);

        const trezorSignParams = {
            device: device,
            path: Wallet.getWalletPath(),
            transaction: {
                chainId: 1,
                nonce: web3.utils.toHex('0'),
                gasPrice: web3.utils.toHex('0'),
                gasLimit: web3.utils.toHex('0'),
                to: "0000000000000000000000000000000000000000",
                value: web3.utils.toHex('0'),
                data: payload,
            },
        };
        const signedTx = await TrezorConnect.ethereumSignTransaction(trezorSignParams);
        if (!signedTx.success) {
            throw new Error((signedTx.payload && signedTx.payload.error) || "Failed to sign transaction.");
        }
        const signedState = signedTx.device && signedTx.device.state && signedTx.device.state.staticSessionId;
        if (signedState !== expectedState) {
            throw new Error("The active Trezor session changed. Reconnect your device before signing.");
        }
        let signature = signedTx.payload.r + signedTx.payload.s.slice(2) + (parseInt(signedTx.payload.v, 16) - 37).toString().padStart(2, '0');
        unsignedTx.setSignature(signature);
        let signedRawTxBytes = ThetaJS.TxSigner.serializeTx(unsignedTx);
        let signedTxRaw = signedRawTxBytes.toString('hex');

        //Remove the '0x' until the RPC endpoint supports '0x' prefixes
        // signedTxRaw = signedTxRaw.substring(2);

        if(signedTxRaw){
            return signedTxRaw;
        }
        else{
            throw new Error("Failed to sign transaction.");
        }
    }
}
